import { styled } from "@mui/material/styles";

import { mutedColor } from "~/styles/redesignColors";

export const Root = styled("p")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  margin: 0,
  padding: "6px 0 6px 3px",
  fontSize: 11,
  lineHeight: 1.4,
  color: mutedColor(theme),
  whiteSpace: "nowrap",

  [theme.breakpoints.down("sm")]: {
    whiteSpace: "normal",
  },

  "& .MuiSvgIcon-root": {
    flex: "none",
    fontSize: 14,
  },
}));
